module.exports = __webpack_public_path__ + "static/media/background.a094b90e.png";